import React from "react";
import Cookies from "universal-cookie";
import { ROLE } from "../../config";
import AdminPettyCashDetail from "../../components/petty_cash/AdminPettyCashDetail";
import NotAllowed from "../errors/NotAllowed";

const cookies = new Cookies();

function PettyCashDetail() {
  const role = cookies.get(ROLE);

  if (role === "COMPANY_ADMIN") {
    return <AdminPettyCashDetail />;
  }

  return <NotAllowed />;
}

export default PettyCashDetail;
